class FeaturedCollectionLoadMore extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector("[data-featured-load-more-button]");
    this.status = this.querySelector("[data-featured-load-more-status]");
    if (!this.button || this.button.dataset.loadMoreReady === "true") return;
    this.button.dataset.loadMoreReady = "true";
    this.button.addEventListener("click", () => this.loadNextPage());
  }

  async loadNextPage() {
    if (!this.dataset.nextUrl || this.button.disabled) return;

    const idleLabel = this.button.querySelector("[data-load-more-idle]");
    const loadingLabel = this.button.querySelector("[data-load-more-loading]");
    this.button.disabled = true;
    this.button.setAttribute("aria-busy", "true");
    idleLabel?.setAttribute("hidden", "");
    loadingLabel?.removeAttribute("hidden");
    if (this.status) this.status.textContent = loadingLabel?.textContent?.trim() || "";

    try {
      const url = new URL(this.dataset.nextUrl, window.location.origin);
      url.searchParams.set("section_id", this.dataset.sectionId);
      const response = await fetch(url.toString(), {
        headers: { Accept: "text/html" },
        credentials: "same-origin",
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const documentFragment = new DOMParser().parseFromString(html, "text/html");
      const selector = `[data-featured-products-grid="${CSS.escape(this.dataset.sectionId)}"]`;
      const currentGrid = document.querySelector(selector);
      const nextGrid = documentFragment.querySelector(selector);
      if (!currentGrid || !nextGrid || nextGrid.children.length === 0) {
        throw new Error("No additional products were returned");
      }

      [...nextGrid.children].forEach((card) => currentGrid.append(card));
      const nextLoader = documentFragment.querySelector(
        `featured-collection-load-more[data-section-id="${CSS.escape(this.dataset.sectionId)}"]`,
      );
      if (nextLoader?.dataset.nextUrl) {
        this.dataset.nextUrl = nextLoader.dataset.nextUrl;
        this.button.disabled = false;
        this.button.removeAttribute("aria-busy");
        idleLabel?.removeAttribute("hidden");
        loadingLabel?.setAttribute("hidden", "");
        if (this.status) this.status.textContent = "";
      } else {
        this.remove();
      }
    } catch (error) {
      this.button.disabled = false;
      this.button.removeAttribute("aria-busy");
      idleLabel?.removeAttribute("hidden");
      loadingLabel?.setAttribute("hidden", "");
      if (this.status) this.status.textContent = this.dataset.errorMessage || "";
      console.error("Featured collection load more failed", error);
    }
  }
}

if (!customElements.get("featured-collection-load-more")) {
  customElements.define("featured-collection-load-more", FeaturedCollectionLoadMore);
}
